import React, {Component} from 'react'
import {authenticationService} from '../../../services/AuthenticationService';

import SvGraphics from "../../../assets/SvGraphics";
import {history} from "../../../utils/history";
import * as Yup from "yup";
import validationHelper from "../../../utils/validationHelper";
import utils from "../../../utils/utils";
import Error from "../../../components/single_components/Error";
import Constants from "../../../utils/constants";
import Config from "../../../config/Config";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import ReCaptcha from "../ReCaptcha";
import Translate from "../../../utils/Translate";
import ReactFlagsSelect from "react-flags-select";
import LeumitLogo from "../../../assets/LeumitLogo.png"
import {appendIchilovQuery, hasIchilovQuery} from "../../../utils/routeUtils";
import ichilovImg from '../../../assets/Soraski.svg';

class Login_LeumitComposed extends Component {
    constructor(props) {
        super(props);

        if (authenticationService.currentUserValue) {
            this.props.history.push(appendIchilovQuery('/dashboard'))
        }
        this.recaptchaRef = React.createRef()

        this.state = {
            username: '',
            password: '',
            auth: {},
            isErr: false,
            errMessage: '',
            errors: {},
            errorsOnSave: {},
        }
    }

    initValidation = async () => {
        let {t} = this.props
        let validationSchema = Yup.object().shape({
            username: Yup.string().min(6, t('defaults.login.username_empty_inv')).matches(Constants.emailRegExp, t('defaults.login.username_inv')).required(t('defaults.login.username_req')),
            password: Yup.string().required(t('defaults.login.pwd_req')),
            //.matches(Config.passwordRegExp,'Password must contain at least one of: a-z, A-z, 0-9 and (!,@,#,$,%,^,*,) with length of 8-20')
        })
        let errors = await validationHelper.validate(this.state.auth, validationSchema)
        await this.setState({
            validationSchema,
            errors
        })
    }

    componentDidMount() {
        let language = localStorage.getItem('language');
        localStorage.clear();
        language = language && language.length>0?language:"he"

        localStorage.setItem('language', language);
    }

    async componentWillMount() {
        await this.initValidation()
    }

    onSubmit = async () => {
        let isLocal = process.env.REACT_APP_ENV === 'localhost'

        if (!isLocal) {
            await this.recaptchaRef.reset()
            await this.recaptchaRef.execute()
        } else {
            await this.submitData("NOTOKENINLOCAL");
        }

    }

    submitData = async (reCaptchaToken) => {
        let {t} = this.props
        if (!utils.isEmpty(this.state.errors)) {
            this.setState({errorsOnSave: this.state.errors});
            return;
        }
        let {username, password} = this.state
        let response = await authenticationService.login(username, password, reCaptchaToken);

        if (response.status < 400) {
            let data = response.data

            if (data.profile.Leumit_clinic !== "T" && (data.role[0] === "Patient" || data.role[0] === "Doctor")) {
                await this.setUserName({target: {value: ''}})
                await this.setPassword({target: {value: ''}})
                this.setState({
                    isErr: true,
                    errMessage: response.data && response.data.message ? response.data.message : t('defaults.login.usernameError'),
                })
                await authenticationService.logout()

            } else {
                if (data && data.hasOwnProperty('status') && String(data['status']).toLowerCase() === 'pass') {
                    if (data.hasOwnProperty('updatePassword') && data['updatePassword'] === true) {
                        const {from} = {from: {pathname: appendIchilovQuery("/pain_create_password")}};
                        this.props.history.push(from);
                    } else if (data.hasOwnProperty('updatePassword') && data['updatePassword'] === false) {
                        if (data['role'][0] === "Patient") {
                            let language = localStorage.getItem('language');
                            localStorage.clear();
                            language = language && language.length>0?language:"he"

                            localStorage.setItem('language', language);
                            let patientInfo = data
                            history.push({
                                pathname: appendIchilovQuery(`/pain_patient_self_onboard`),
                                state: {
                                    patientInfo,
                                    from: {
                                        fromPath: appendIchilovQuery(`/pain_patient_self_onboard`),
                                    }
                                },
                            })
                        } else {
                            const {from} = {from: {pathname: appendIchilovQuery("/pain_requests_dashboard")}};
                            this.props.history.push(from);
                        }
                    }
                } else if (data && data.hasOwnProperty('status') && String(data['status']).toLowerCase() === '2fa') {
                    const {from} = {from: {pathname:appendIchilovQuery("/pain_2FA")}};
                    this.props.history.push(from);
                } else {
                    await this.setUserName({target: {value: ''}})
                    await this.setPassword({target: {value: ''}})
                    this.setState({
                        isErr: true,
                        errMessage: response.data && response.data.message ? response.data.message : t('defaults.login.connectionError'),
                    })
                }
            }

            // utils.set(data,'status','pass')
            // utils.set(data,'updatePassword',true)

        } else {
            await this.setUserName({target: {value: ''}})
            await this.setPassword({target: {value: ''}})
            this.setState({
                isErr: true,
                errMessage: response.data && response.data.message ? response.data.message : t('defaults.login.connectionError'),
            })
        }
    }

    setUserName = async (e) => {
        let {auth, validationSchema} = this.state
        this.setState({username: e.target.value.trim()})
        utils.set(auth, 'username', e.target.value.trim())
        let errors = await validationHelper.validate(auth, validationSchema);
        let errorsOnSave = this.state.errorsOnSave;
        if (utils.get(errorsOnSave, 'username')) {
            utils.set(errorsOnSave, 'username', utils.get(errors, 'username'))
        }
        this.setState({
            auth,
            errors,
            errorsOnSave,
            isErr: false, errMessage: ''
        })
    }

    setPassword = async (e) => {
        let {auth, validationSchema} = this.state
        this.setState({password: e.target.value.trim()})
        utils.set(auth, 'password', e.target.value.trim())
        let errors = await validationHelper.validate(auth, validationSchema);
        let errorsOnSave = this.state.errorsOnSave;
        if (utils.get(errorsOnSave, 'password')) {
            utils.set(errorsOnSave, 'password', utils.get(errors, 'password'))
        }
        this.setState({
            auth,
            errors,
            errorsOnSave,
            isErr: false, errMessage: ''
        })
    }

    resetPassword = () => {
        history.push({
            pathname: appendIchilovQuery('/pain_reset_password'),
            state: {
                Email: this.state.username,
                from: {
                    fromPath: appendIchilovQuery(`/login_pain`),
                }
            },
        })
    }

    gotoPatientLogin() {

        this.props.history.push(appendIchilovQuery('/pain_patient_login'))

    }

    gotoRegister() {
        this.props.history.push(appendIchilovQuery('/register_pain'))

    }

    async onSelectFlag(e) {
        e = e && e.length>0?e:"he"
        localStorage.setItem('language', e)
        let lang = Translate.getLanguage(e);
        let language = await Translate.setLanguageLocal(lang);
        const {i18n} = this.props;
        await i18n.changeLanguage(language);
        if (Translate.rtl.includes(language)) document.getElementsByTagName("html")[0].setAttribute("dir", "rtl")
        else document.getElementsByTagName("html")[0].setAttribute("dir", "ltr")
    }

    render() {
        let {t} = this.props
        return (
            <div className={"login-page-Leumit"}>
                <div className={'sade-right-changeLang'}>

                    <ReactFlagsSelect selectButtonClassName={'language-select-button'}
                                      className={'sade-right-navbar-content'}
                                      placeholder={t('patient_boarding.choose_language')}
                                      defaultCountry={Translate.getCurrentCountry()}
                                      countries={Translate.getCountries()} showSelectedLabel={true}
                                      showOptionLabel={true} selectedSize={14}
                                      selected={Translate.getCurrentCountry(localStorage.getItem('language'))}
                                      onSelect={e => this.onSelectFlag(e)}
                                      customLabels={{
                                          "US": "EN",
                                          "IL": "עב",
                                      }}
                    />
                </div>
                <div className={'sade-Pain-login-logo-container'}>
                    <SvGraphics svgname={'painClinicLogo'} className={'sade-Pain-login-logo'}/>
                    {hasIchilovQuery() ? <img src={ichilovImg} className={'sade-Pain-login-logo'} alt={""}/> :
                        <img src={LeumitLogo} className={'sade-Pain-login-logo'} alt={""}/>
                    }

                    <ReactFlagsSelect selectButtonClassName={'language-select-button'}
                                      className={'sade-right-language-content'}
                                      placeholder={t('patient_boarding.choose_language')}
                                      defaultCountry={Translate.getCurrentCountry()}
                                      countries={Translate.getCountries()} showSelectedLabel={true}
                                      showOptionLabel={true} selectedSize={14}
                                      selected={Translate.getCurrentCountry(localStorage.getItem('language'))}
                                      onSelect={e => this.onSelectFlag(e)}
                                      customLabels={{
                                          "US": "EN",
                                          "IL": "עב",
                                      }}
                    />
                </div>
                <div className={'sade-login-main-board'}>
                    <label className={'sade-login-label-loginID'}>{t('defaults.login.login')}</label>
                    <div className={'sade-login-form-container-reg'}>
                        <div className={'sade-Pain-login-form'}>
                            <div>
                                <div className={"login-input-wrapper form-group leumit-login-form-group"}>
                                    <input className={"sade-registration-input-field"}
                                           placeholder={t('defaults.login.username')}
                                           type={"text"}
                                           name={"Username"}
                                           id={"search"}
                                           value={this.state.username}
                                           onChange={e => this.setUserName(e)}
                                           onKeyPress={event => {
                                               if (event.key === 'Enter') {
                                                   this.onSubmit()
                                               }
                                           }}/>
                                    <SvGraphics
                                        className={!!utils.get(this.state.errorsOnSave, 'ID_passport') ? "input-pic2" : "input-pic"}
                                        svgname={'person'}
                                        style={{width: '20px', height: '20px'}}/>
                                </div>

                                <Error isNonFloat={true}
                                       errorMessage={utils.get(this.state.errorsOnSave, 'password')}
                                       isShown={!!utils.get(this.state.errorsOnSave, 'password')}/>
                            </div>

                            <div>

                                <div className={"login-input-wrapper form-group leumit-login-form-group"}>
                                    <input className={"sade-registration-input-field"}
                                           placeholder={t('defaults.login.pwd')}
                                           type={"password"}
                                           name={""}
                                           value={this.state.password}
                                           onChange={e => this.setPassword(e)}
                                           onKeyPress={event => {
                                               if (event.key === 'Enter') {
                                                   this.onSubmit()
                                               }
                                           }}/>
                                    <SvGraphics
                                        className={!!utils.get(this.state.errorsOnSave, 'Phone_num1') ? "input-pic2" : "input-pic"}
                                        svgname={'pass1'}
                                        style={{width: '20px', height: '20px'}}/>
                                </div>
                                <Error isNonFloat={true}
                                       errorMessage={utils.get(this.state.errorsOnSave, 'Last_name')}
                                       isShown={!!utils.get(this.state.errorsOnSave, 'Last_name')}/>
                            </div>


                            <div className="form-group leumit-login-form-group">
                                <button className="sade-login-form-button"
                                        onClick={this.onSubmit.bind(this)}>{t('defaults.login.login')}</button>
                            </div>
                            <div className={'leumit-login-footer-forget'} onClick={this.resetPassword.bind(this)}>
                                <a>{t('defaults.login.forgot_pwd')}?</a>
                            </div>
                            <div className="leumit-login-selection" style={{marginTop: '15px'}}>
                                <div className={'account-exists-block'} onClick={() => this.gotoRegister()}>
                                    <SvGraphics svgname={'enter'}
                                                style={{minWidth: '14px', width: '14px', marginTop: '-6px'}}/>
                                    <div className="account-exists">{t('defaults.login.Register')}</div>
                                </div>
                                <div className={"account-exists-space"}/>
                                <div className={'account-exists-block'} onClick={() => this.gotoPatientLogin()}>
                                    <SvGraphics svgname={'stethoscope'}
                                                style={{minWidth: '14px', width: '14px', marginTop: '-6px'}}/>
                                    <div className="account-exists"
                                    >{t('defaults.Registration.patient_signIn')}</div>
                                </div>
                            </div>

                            <div className={'leumit-login-form-group loginError red'}>
                                <Error isNonFloat={true}
                                       errorMessage={t('defaults.Registration.reg_err') + ': ' + this.state.errMessage}
                                       isShown={this.state.isErr}/>
                            </div>
                        </div>

                    </div>


                </div>

                <div className={'sade-Pain-bottom-container2'}>
                    <div className="need-help-label">
                        {t('defaults.Registration.need_help')}
                    </div>

                    <div className="need-help-block">

                        <div className="need-help-block-content">
                            <SvGraphics svgname={'global'} className={"login-website-icon"}/>

                            <div className={"login-website-div"}>
                                <a className={"login-website-label"} target={"_blank"}
                                   href={'https://www.sade.group/he/pain'}>www.sade.group</a>
                            </div>

                        </div>
                        <div className="need-help-block-content">
                            <SvGraphics svgname={'email-icon'} className={"login-website-icon"}/>

                            <div className={"login-website-div"}>

                                <a className={"login-website-label"}
                                   href="mailto: pain@sade.group">pain@sade.group</a>
                            </div>

                        </div>


                        <div className="need-help-block-content">
                            <SvGraphics svgname={'phone-icon'} className={"login-website-icon"}/>

                            <div className={"login-website-div"}>
                                <a className={"login-website-label"} href="tel:073-380-7972">073-380-7972</a>
                            </div>
                        </div>
                        <div className="need-help-block-content">
                            <SvGraphics svgname={'clock'} className={"login-website-icon"}/>

                            <div className={"login-website-div"}>

                                <a className={"login-website-label"}
                                   href="">{t('patient_self_boarding.workingHours')}</a>
                            </div>

                        </div>
                    </div>
                </div>

                <div className={'login-version-element'}>
                        <div className={'login-version-element-label'}>Version:</div>
                        <div className={'login-version-element-value'}>{Config.version} {Config.build}</div>
                    </div>


                <div className={'recaptcha-block'}>
                    <ReCaptcha setRef={ref => (this.recaptchaRef = ref)}
                               action={async (reCaptchaToken) => {
                                   await this.submitData(reCaptchaToken);
                               }}
                        /*setErr={ this.setRecapchaErrors()}*//>
                </div>

            </div>

        )
    }
}

let Login_Leumit = compose(
    withTranslation()
)(Login_LeumitComposed)
export default Login_Leumit;
